import React, { ReactNode } from 'react';
  import { useTranslation } from 'react-i18next';
  import Button from '../../buttons/Button';
  import styles from './ErrorFallback.css';

  interface ErrorFallbackProps {
    onReturnClick: () => void;
    errorMessage?: string | string[];
    showIcon?: boolean;
    icon?: ReactNode;
    buttonText?: string;
  }

  const ErrorFallback = ({
    onReturnClick,
    errorMessage,
    showIcon = false,
    icon,
    buttonText,
  }: ErrorFallbackProps) => {
    const { t } = useTranslation();

    // Default error messages if none provided
    const defaultMessages = [
      t('ERRORS.UNKNOWN_ERROR_LINE_1'),
      t('ERRORS.UNKNOWN_ERROR_LINE_2')
    ];

    // Convert errorMessage to array for consistent handling
    let messages: string[];
    if (errorMessage) {
      messages = Array.isArray(errorMessage) ? errorMessage : [errorMessage];
    } else {
      messages = defaultMessages;
    }

    const displayButtonText = buttonText || t('WAFFLE_MENU.RETURN_TO_PENDING_ORDERS');

    return (
      <div className={styles.errorOverlay}>
        <div className={styles.errorContent}>
          {showIcon && icon && (
            <div className={styles.iconContainer}>
              {icon}
            </div>
          )}
          {messages.map((message) => (
            <p key={message} className={styles.errorMessage}>
              {message}
            </p>
          ))}
        </div>
        <div className={styles.buttonContainer}>
          <Button onClick={onReturnClick} className={styles.button}>
            {displayButtonText}
          </Button>
        </div>
      </div>
    );
  };

  export default ErrorFallback;